import {
  AuthenticationApi,
  BookingServicesApi,
  BookingsApi,
  BookingsWriteApi,
  Configuration,
  ServiceCategoriesApi,
  ServiceStatisticsApi,
  EmployeesApi,
  SalonDataControllerApi,
  SalonsApi,
  WorkingHoursApi,
  StaffApi,
  ServicesLoVApi,
  BookingListApi,
  CustomerApi,
  AbsencesApi,
} from '@api/generated';

const config = new Configuration({
  // Calls go through reservare-bff: it validates the session cookie and
  // injects the Authorization Bearer header before forwarding to reservare-be.
  basePath: '/api/services/reservare-be',
  baseOptions: {
    withCredentials: true,
    headers: {
      'X-Auth': 'Auth0',
    },
  },
});

export const authenticationApi = new AuthenticationApi(config);
export const bookingServicesApi = new BookingServicesApi(config);
export const bookingsApi = new BookingsApi(config);
export const bookingsWriteApi = new BookingsWriteApi(config);
export const serviceCategoriesApi = new ServiceCategoriesApi(config);
export const serviceStatisticsApi = new ServiceStatisticsApi(config);
export const employeesApi = new EmployeesApi(config);
export const salonDataApi = new SalonDataControllerApi(config);
export const salonsApi = new SalonsApi(config);
export const workingHoursApi = new WorkingHoursApi(config);
export const staffApi = new StaffApi(config);
export const servicesLoVApi = new ServicesLoVApi(config);
export const bookingListApi = new BookingListApi(config);
export const customerApi = new CustomerApi(config);
export const absencesApi = new AbsencesApi(config);
export const api = config;
